import { Loader2 } from 'lucide-react';

export function LoadingScreen({ message = 'Loading Lumora...' }: { message?: string }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-navy-dark">
      <div className="flex flex-col items-center gap-6 animate-fade-in">
        <img
          src="/lumora-logo-refined.svg"
          alt="Lumora"
          className="h-12 w-auto animate-pulse"
        />
        <div className="flex items-center gap-3">
          <Loader2 size={20} className="animate-spin text-gold" />
          <span className="text-white/60 text-sm font-body">{message}</span>
        </div>
      </div>
    </div>
  );
}

export function PageLoader({ label = 'Loading page', variant = 'cards' }: { label?: string; variant?: 'cards' | 'table' }) {
  return (
    <div role="status" aria-label={label} aria-busy="true" className="min-h-64 w-full">
      <span className="sr-only">{label}…</span>
      <div aria-hidden="true">
        {variant === 'table' ? <SkeletonTable /> : <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          {Array.from({ length: 3 }, (_, index) => <SkeletonCard key={index} />)}
        </div>}
      </div>
    </div>
  );
}

export function SkeletonCard({ className = '' }: { className?: string }) {
  return (
    <div className={`lum-card p-5 ${className}`}>
      <div className="animate-pulse space-y-3">
        <div className="skeleton h-4 w-3/4" />
        <div className="skeleton h-3 w-1/2" />
        <div className="skeleton h-3 w-5/6" />
        <div className="flex gap-2 mt-4">
          <div className="skeleton h-6 w-16 rounded-full" />
          <div className="skeleton h-6 w-20 rounded-full" />
        </div>
      </div>
    </div>
  );
}

export function SkeletonTable({ rows = 6, columns = 5 }: { rows?: number; columns?: number }) {
  return <div className="lum-card overflow-hidden">
    <div className="p-4 border-b border-gray-100 flex gap-4">{Array.from({ length: columns }).map((_, i) => <div key={i} className="skeleton h-3 flex-1" />)}</div>
    <div className="divide-y divide-gray-100">{Array.from({ length: rows }).map((_, row) => <div key={row} className="p-4 flex items-center gap-4">{Array.from({ length: columns }).map((_, col) => <div key={col} className={`skeleton h-4 ${col === 0 ? 'w-2/5' : 'flex-1'}`} />)}</div>)}</div>
  </div>;
}
